module.exports = __webpack_public_path__ + "img/eyebrow_male_arched_thin.65ed0c53.png";